import React, { useEffect, useState } from "react";
import {

  FaPlayCircle,
  FaCalendarAlt,
  FaClock,
  FaCheckCircle,
  FaGlobe,
} from "react-icons/fa";
import "../assets/css/DemoDetails.css";
import { useNavigate } from "react-router-dom";
import { getCompanyData } from "../Service/apiService"; 
let cachedStats = {
  totalDemo: 0,
    renewalDemo: 0,
    newDemo: 0,
    personalMeeting: 0,
    indiaDemo: 0,
    foreignDemo: 0,
};
const hasValidStats = (stats) => {
  return Object.values(stats).some(value => value > 0);
};

export default function DemoDetails() {
  const navigate = useNavigate();

   const [stats, setStats] = useState(() => ({ ...cachedStats }));

  // Helper: parse count fields like "3", "0", ">5"
  const parseCountField = (val) => {
    if (val == null) return 0;
    if (typeof val === "string" && val.startsWith(">")) return 6;
    return parseInt(val) || 0;
  };

  const isNotInternal = (c) =>
    (c.companyType || "").toLowerCase() !== "internal";

   const [loading, setLoading] = useState(() => !hasValidStats(cachedStats));
  
    useEffect(() => {
      // Only fetch if we don't have valid cached data
      if (!hasValidStats(cachedStats)) {
        fetchDemoStats();
      }
    }, []);

  const fetchDemoStats = async () => {
    setLoading(true);
    try {
      // Fetch all companies
      const companyRes = await getCompanyData("all");
      const companies = companyRes?.data || [];

      // Filter out internal companies
      const nonInternalCompanies = companies.filter(isNotInternal);

      // 1. Total Demos → sum of `demo` field
      const totalDemo = nonInternalCompanies.reduce(
        (sum, c) => sum + parseCountField(c.demo),
        0
      );

      // 2. Renewal Demos → sum where companyType === "Renewal"
      const renewalDemo = nonInternalCompanies
        .filter((c) => (c.companyType || "").toLowerCase() === "renewal")
        .reduce((sum, c) => sum + parseCountField(c.demo), 0);

      // 3. New Demos → sum where companyType === "New"
      const newDemo = nonInternalCompanies
        .filter((c) => (c.companyType || "").toLowerCase() === "new")
        .reduce((sum, c) => sum + parseCountField(c.demo), 0);

      // 4. Personal Meetings → sum of `personalMeeting` field
      const personalMeeting = nonInternalCompanies.reduce(
        (sum, c) => sum + parseCountField(c.personalMeeting),
        0
      );

      // 5. India Demos
      const indiaDemo = nonInternalCompanies
        .filter((c) => (c.country || "").toLowerCase() === "india")
        .reduce((sum, c) => sum + parseCountField(c.demo), 0);

      // 6. Foreign Demos
      const foreignDemo = nonInternalCompanies
        .filter((c) => (c.country || "").toLowerCase() !== "india")
        .reduce((sum, c) => sum + parseCountField(c.demo), 0);

      const computed = {
        totalDemo,
        renewalDemo,
        newDemo,
        personalMeeting,
        indiaDemo,
        foreignDemo,
      };

       setStats(computed);
    cachedStats = { ...computed };
    } catch (err) {
      console.error("Error loading demo stats:", err);
    }
    finally {
      setLoading(false);
    }

  };


const goToTable = (id) => {
  navigate(`/dashboard/companies/${id}`);
};

  const metrics = [
    {
      id: "total-demo",
      key: "totalDemoCompanies",
      label: "Total Demo",
      value: stats.totalDemo,
      icon: FaPlayCircle,
      color: "rgb(5, 55, 99)",
    },
    {
      id: "renewal-demo",
      key: "renewalDemoCompanies",
      label: "Renewal Demo",
      value: stats.renewalDemo,
      icon: FaCalendarAlt,
      color: "rgb(5, 55, 99)",
    },
    {
      id: "new-demo",
      key: "newDemoCompanies",
      label: "New Demo",
      value: stats.newDemo,
      icon: FaCheckCircle,
      color: "rgb(5, 55, 99)",
    },
    {
      id: "personal-meeting",
      key: "personalMeetingCompanies",
      label: "Personal Meeting",
      value: stats.personalMeeting,
      icon: FaClock,
      color: "rgb(5, 55, 99)",
    },
    {
      id: "india-demo",
      key: "indiaDemoCompanies",
      label: "India Demo",
      value: stats.indiaDemo,
      icon: FaGlobe,
      color: "rgb(5, 55, 99)",
    },
    {
      id: "foreign-demo",
      key: "foreignDemoCompanies",
      label: "Foreign Demo",
      value: stats.foreignDemo,
      icon: FaGlobe,
      color: "rgb(5, 55, 99)",
    },
  ];
  const NumberSkeleton = () => (
    <div className="number-skeleton">
      <div className="skeleton-loader"></div>
    </div>
  );
  return (
    <div className="demo-details-container">
     
      <div className="metrics-grid">
        {metrics.map(({ id, label, value, icon: Icon, color, key }) => (
          <div key={id} className="metric-card" onClick={() => goToTable(key)}>
            <div className="metric-icon" style={{ backgroundColor: color }}>
              <Icon size={18} />
            </div>
            <p className="metric-label">{label}</p>
            {loading ? (
              <NumberSkeleton />
            ) : (
              <p className="metric-value">{value}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
